import { addNotification, closeAllNotifications, show } from "./Notifications";

import { TYPE } from "./Notification";
import component from "./App";
import initializeSvelteApp from "common/initializeSvelteApp";

initializeSvelteApp({
  component,
  target:
    ".tc-admin-header, .tc-main-header, .tc-mobile-header, .tc-mobile-section-tickets, [data-notifications]",
  props: (element) => {
    return {
      notifications:
        JSON.parse(
          document
            .querySelector("[data-flash-messages]")
            .getAttribute("data-flash-messages")
        ) || [],
    };
  },
});

export { show, addNotification, closeAllNotifications, TYPE };
